<template lang="pug">
  .popup-booking.js-popup-booking
    .popup-booking__layout(v-on:click="popupLocal('booking', 'close')")
    .popup-booking__content-wr
      .popup-booking__content-layout
      .popup-booking__close-wr(v-on:click="popupLocal('booking', 'close')")
        SvgIcon(class='popup-booking__close-ico' name="close" width="42" height="42")
      .popup-booking__img-left(:style="{ backgroundImage: `url('${require('@/assets/img/popupBooking/popup-booking-left-img.jpg')}')` }")
      .popup-booking__img-right(:style="{ backgroundImage: `url('${require('@/assets/img/popupBooking/popup-booking-right-img.jpg')}')` }")
      .popup-booking__content
        .popup-booking__title
          | Запланировать визит
        .popup-booking__form
          FormBooking
</template>

<script>
import Vue from 'vue';
import {VueMaskDirective} from 'v-mask';

import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import FormBooking from '@/components/common/formBooking/FormBooking.vue';

Vue.directive('mask', VueMaskDirective);

// @ is an alias to /src

import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';

export default {
  name: 'PopupBooking',

  mixins: [AjaxHelpersVue, PopupHelpersVue],

  components: {
    SvgIcon,
    FormBooking
  },

  data() {
    return {

    }
  },

  created() {

  },

  methods: {
    popupLocal(type, action) {
      this.popup(type, action);
    }
  }
}
</script>
